// This file has been automatically generated based on the WCAG specification.
// Do therefore not modify it directly! If you wish to make changes, do so in
// `scripts/criteria.js` and run `yarn generate` to rebuild this file.
/**
 * @internal
 */
export const Criteria = {
    "1.1.1": {
        title: "Non-text Content",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#non-text-content",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#non-text-content",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#text-equiv-all",
                    level: "A",
                },
            ],
        ],
    },
    "1.2.1": {
        title: "Audio-only and Video-only (Prerecorded)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#audio-only-and-video-only-prerecorded",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#audio-only-and-video-only-prerecorded",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-av-only-alt",
                    level: "A",
                },
            ],
        ],
    },
    "1.2.2": {
        title: "Captions (Prerecorded)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#captions-prerecorded",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#captions-prerecorded",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-captions",
                    level: "A",
                },
            ],
        ],
    },
    "1.2.3": {
        title: "Audio Description or Media Alternative (Prerecorded)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#audio-description-or-media-alternative-prerecorded",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#audio-description-or-media-alternative-prerecorded",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-audio-desc",
                    level: "A",
                },
            ],
        ],
    },
    "1.2.4": {
        title: "Captions (Live)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#captions-live",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#captions-live",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-real-time-captions",
                    level: "AA",
                },
            ],
        ],
    },
    "1.2.5": {
        title: "Audio Description (Prerecorded)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#audio-description-prerecorded",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#audio-description-prerecorded",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-audio-desc-only",
                    level: "AA",
                },
            ],
        ],
    },
    "1.2.6": {
        title: "Sign Language (Prerecorded)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#sign-language-prerecorded",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#sign-language-prerecorded",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-sign",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.2.7": {
        title: "Extended Audio Description (Prerecorded)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#extended-audio-description-prerecorded",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#extended-audio-description-prerecorded",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-extended-ad",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.2.8": {
        title: "Media Alternative (Prerecorded)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#media-alternative-prerecorded",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#media-alternative-prerecorded",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-text-doc",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.2.9": {
        title: "Audio-only (Live)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#audio-only-live",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#audio-only-live",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#media-equiv-live-audio-only",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.3.1": {
        title: "Info and Relationships",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#info-and-relationships",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#info-and-relationships",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#content-structure-separation-programmatic",
                    level: "A",
                },
            ],
        ],
    },
    "1.3.2": {
        title: "Meaningful Sequence",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#meaningful-sequence",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#meaningful-sequence",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#content-structure-separation-sequence",
                    level: "A",
                },
            ],
        ],
    },
    "1.3.3": {
        title: "Sensory Characteristics",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#sensory-characteristics",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#sensory-characteristics",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#content-structure-separation-understanding",
                    level: "A",
                },
            ],
        ],
    },
    "1.3.4": {
        title: "Orientation",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#orientation",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#orientation",
                    level: "AA",
                },
            ],
        ],
    },
    "1.3.5": {
        title: "Identify Input Purpose",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#identify-input-purpose",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#identify-input-purpose",
                    level: "AA",
                },
            ],
        ],
    },
    "1.3.6": {
        title: "Identify Purpose",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#identify-purpose",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#identify-purpose",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.4.1": {
        title: "Use of Color",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#use-of-color",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#use-of-color",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-without-color",
                    level: "A",
                },
            ],
        ],
    },
    "1.4.2": {
        title: "Audio Control",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#audio-control",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#audio-control",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-dis-audio",
                    level: "A",
                },
            ],
        ],
    },
    "1.4.3": {
        title: "Contrast (Minimum)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#contrast-minimum",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#contrast-minimum",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast",
                    level: "AA",
                },
            ],
        ],
    },
    "1.4.4": {
        title: "Resize Text",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#resize-text",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#resize-text",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-scale",
                    level: "AA",
                },
            ],
        ],
    },
    "1.4.5": {
        title: "Images of Text",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#images-of-text",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#images-of-text",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-text-presentation",
                    level: "AA",
                },
            ],
        ],
    },
    "1.4.6": {
        title: "Contrast (Enhanced)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#contrast-enhanced",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#contrast-enhanced",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast7",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.4.7": {
        title: "Low or No Background Audio",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#low-or-no-background-audio",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#low-or-no-background-audio",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-noaudio",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.4.8": {
        title: "Visual Presentation",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#visual-presentation",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#visual-presentation",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-visual-presentation",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.4.9": {
        title: "Images of Text (No Exception)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#images-of-text-no-exception",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#images-of-text-no-exception",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#visual-audio-contrast-text-images",
                    level: "AAA",
                },
            ],
        ],
    },
    "1.4.10": {
        title: "Reflow",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#reflow",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#reflow",
                    level: "AA",
                },
            ],
        ],
    },
    "1.4.11": {
        title: "Non-text Contrast",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#non-text-contrast",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#non-text-contrast",
                    level: "AA",
                },
            ],
        ],
    },
    "1.4.12": {
        title: "Text Spacing",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#text-spacing",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#text-spacing",
                    level: "AA",
                },
            ],
        ],
    },
    "1.4.13": {
        title: "Content on Hover or Focus",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#content-on-hover-or-focus",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#content-on-hover-or-focus",
                    level: "AA",
                },
            ],
        ],
    },
    "2.1.1": {
        title: "Keyboard",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#keyboard",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#keyboard",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#keyboard-operation-keyboard-operable",
                    level: "A",
                },
            ],
        ],
    },
    "2.1.2": {
        title: "No Keyboard Trap",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#no-keyboard-trap",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#no-keyboard-trap",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#keyboard-operation-trapping",
                    level: "A",
                },
            ],
        ],
    },
    "2.1.3": {
        title: "Keyboard (No Exception)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#keyboard-no-exception",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#keyboard-no-exception",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#keyboard-operation-all-funcs",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.1.4": {
        title: "Character Key Shortcuts",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#character-key-shortcuts",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#character-key-shortcuts",
                    level: "A",
                },
            ],
        ],
    },
    "2.2.1": {
        title: "Timing Adjustable",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#timing-adjustable",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#timing-adjustable",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#time-limits-required-behaviors",
                    level: "A",
                },
            ],
        ],
    },
    "2.2.2": {
        title: "Pause, Stop, Hide",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#pause-stop-hide",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#pause-stop-hide",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#time-limits-pause",
                    level: "A",
                },
            ],
        ],
    },
    "2.2.3": {
        title: "No Timing",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#no-timing",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#no-timing",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#time-limits-no-exceptions",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.2.4": {
        title: "Interruptions",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#interruptions",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#interruptions",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#time-limits-postponed",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.2.5": {
        title: "Re-authenticating",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#re-authenticating",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#re-authenticating",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#time-limits-server-timeout",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.2.6": {
        title: "Timeouts",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#timeouts",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#timeouts",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.3.1": {
        title: "Three Flashes or Below Threshold",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#three-flashes-or-below-threshold",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#three-flashes-or-below-threshold",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#seizure-does-not-violate",
                    level: "A",
                },
            ],
        ],
    },
    "2.3.2": {
        title: "Three Flashes",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#three-flashes",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#three-flashes",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#seizure-three-times",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.3.3": {
        title: "Animation from Interactions",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#animation-from-interactions",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#animation-from-interactions",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.4.1": {
        title: "Bypass Blocks",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#bypass-blocks",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#bypass-blocks",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-skip",
                    level: "A",
                },
            ],
        ],
    },
    "2.4.2": {
        title: "Page Titled",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#page-titled",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#page-titled",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-title",
                    level: "A",
                },
            ],
        ],
    },
    "2.4.3": {
        title: "Focus Order",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#focus-order",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#focus-order",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-focus-order",
                    level: "A",
                },
            ],
        ],
    },
    "2.4.4": {
        title: "Link Purpose (In Context)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#link-purpose-in-context",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#link-purpose-in-context",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-refs",
                    level: "A",
                },
            ],
        ],
    },
    "2.4.5": {
        title: "Multiple Ways",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#multiple-ways",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#multiple-ways",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-mult-loc",
                    level: "AA",
                },
            ],
        ],
    },
    "2.4.6": {
        title: "Headings and Labels",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#headings-and-labels",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#headings-and-labels",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-descriptive",
                    level: "AA",
                },
            ],
        ],
    },
    "2.4.7": {
        title: "Focus Visible",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#focus-visible",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#focus-visible",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-focus-visible",
                    level: "AA",
                },
            ],
        ],
    },
    "2.4.8": {
        title: "Location",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#location",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#location",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-location",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.4.9": {
        title: "Link Purpose (Link Only)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#link-purpose-link-only",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#link-purpose-link-only",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-link",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.4.10": {
        title: "Section Headings",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#section-headings",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#section-headings",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#navigation-mechanisms-headings",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.4.11": {
        title: "Focus Not Obscured (Minimum)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#focus-not-obscured-minimum",
                    level: "AA",
                },
            ],
        ],
    },
    "2.4.12": {
        title: "Focus Not Obscured (Enhanced)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#focus-not-obscured-enhanced",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.4.13": {
        title: "Focus Appearance",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#focus-appearance",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.5.1": {
        title: "Pointer Gestures",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#pointer-gestures",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#pointer-gestures",
                    level: "A",
                },
            ],
        ],
    },
    "2.5.2": {
        title: "Pointer Cancellation",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#pointer-cancellation",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#pointer-cancellation",
                    level: "A",
                },
            ],
        ],
    },
    "2.5.3": {
        title: "Label in Name",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#label-in-name",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#label-in-name",
                    level: "A",
                },
            ],
        ],
    },
    "2.5.4": {
        title: "Motion Actuation",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#motion-actuation",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#motion-actuation",
                    level: "A",
                },
            ],
        ],
    },
    "2.5.5": {
        title: "Target Size (Enhanced)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#target-size-enhanced",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#target-size",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.5.6": {
        title: "Concurrent Input Mechanisms",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#concurrent-input-mechanisms",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#concurrent-input-mechanisms",
                    level: "AAA",
                },
            ],
        ],
    },
    "2.5.7": {
        title: "Dragging Movements",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#dragging-movements",
                    level: "AA",
                },
            ],
        ],
    },
    "2.5.8": {
        title: "Target Size (Minimum)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#target-size-minimum",
                    level: "AA",
                },
            ],
        ],
    },
    "3.1.1": {
        title: "Language of Page",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#language-of-page",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#language-of-page",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#meaning-doc-lang-id",
                    level: "A",
                },
            ],
        ],
    },
    "3.1.2": {
        title: "Language of Parts",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#language-of-parts",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#language-of-parts",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#meaning-other-lang-id",
                    level: "AA",
                },
            ],
        ],
    },
    "3.1.3": {
        title: "Unusual Words",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#unusual-words",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#unusual-words",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#meaning-idioms",
                    level: "AAA",
                },
            ],
        ],
    },
    "3.1.4": {
        title: "Abbreviations",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#abbreviations",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#abbreviations",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#meaning-located",
                    level: "AAA",
                },
            ],
        ],
    },
    "3.1.5": {
        title: "Reading Level",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#reading-level",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#reading-level",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#meaning-supplements",
                    level: "AAA",
                },
            ],
        ],
    },
    "3.1.6": {
        title: "Pronunciation",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#pronunciation",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#pronunciation",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#meaning-pronunciation",
                    level: "AAA",
                },
            ],
        ],
    },
    "3.2.1": {
        title: "On Focus",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#on-focus",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#on-focus",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#consistent-behavior-receive-focus",
                    level: "A",
                },
            ],
        ],
    },
    "3.2.2": {
        title: "On Input",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#on-input",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#on-input",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#consistent-behavior-unpredictable-change",
                    level: "A",
                },
            ],
        ],
    },
    "3.2.3": {
        title: "Consistent Navigation",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#consistent-navigation",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#consistent-navigation",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#consistent-behavior-consistent-locations",
                    level: "AA",
                },
            ],
        ],
    },
    "3.2.4": {
        title: "Consistent Identification",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#consistent-identification",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#consistent-identification",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#consistent-behavior-consistent-functionality",
                    level: "AA",
                },
            ],
        ],
    },
    "3.2.5": {
        title: "Change on Request",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#change-on-request",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#change-on-request",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#consistent-behavior-no-extreme-changes-context",
                    level: "AAA",
                },
            ],
        ],
    },
    "3.2.6": {
        title: "Consistent Help",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#consistent-help",
                    level: "A",
                },
            ],
        ],
    },
    "3.3.1": {
        title: "Error Identification",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#error-identification",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#error-identification",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#minimize-error-identified",
                    level: "A",
                },
            ],
        ],
    },
    "3.3.2": {
        title: "Labels or Instructions",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#labels-or-instructions",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#labels-or-instructions",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#minimize-error-cues",
                    level: "A",
                },
            ],
        ],
    },
    "3.3.3": {
        title: "Error Suggestion",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#error-suggestion",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#error-suggestion",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#minimize-error-suggestions",
                    level: "AA",
                },
            ],
        ],
    },
    "3.3.4": {
        title: "Error Prevention (Legal, Financial, Data)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#error-prevention-legal-financial-data",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#error-prevention-legal-financial-data",
                    level: "AA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#minimize-error-reversible",
                    level: "AA",
                },
            ],
        ],
    },
    "3.3.5": {
        title: "Help",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#help",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#help",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#minimize-error-context-help",
                    level: "AAA",
                },
            ],
        ],
    },
    "3.3.6": {
        title: "Error Prevention (All)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#error-prevention-all",
                    level: "AAA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#error-prevention-all",
                    level: "AAA",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#minimize-error-reversible-all",
                    level: "AAA",
                },
            ],
        ],
    },
    "3.3.7": {
        title: "Redundant Entry",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#redundant-entry",
                    level: "A",
                },
            ],
        ],
    },
    "3.3.8": {
        title: "Accessible Authentication (Minimum)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#accessible-authentication-minimum",
                    level: "AA",
                },
            ],
        ],
    },
    "3.3.9": {
        title: "Accessible Authentication (Enhanced)",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#accessible-authentication-enhanced",
                    level: "AAA",
                },
            ],
        ],
    },
    "4.1.2": {
        title: "Name, Role, Value",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#name-role-value",
                    level: "A",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#name-role-value",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#ensure-compat-rsv",
                    level: "A",
                },
            ],
        ],
    },
    "4.1.3": {
        title: "Status Messages",
        versions: [
            [
                "2.2",
                {
                    uri: "https://www.w3.org/TR/WCAG2/#status-messages",
                    level: "AA",
                },
            ],
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#status-messages",
                    level: "AA",
                },
            ],
        ],
    },
    "4.1.1": {
        title: "Parsing",
        versions: [
            [
                "2.1",
                {
                    uri: "https://www.w3.org/TR/WCAG21/#parsing",
                    level: "A",
                },
            ],
            [
                "2.0",
                {
                    uri: "https://www.w3.org/TR/WCAG20/#ensure-compat-parses",
                    level: "A",
                },
            ],
        ],
    },
};
//# sourceMappingURL=data.js.map